<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@ui/components/collapsible';
  import { cn } from '@ui/utils/utils';

  import Card from './Card.vue';
  import CardHeader from './CardHeader.vue';

  const props = defineProps<{
    class?: HTMLAttributes['class'];
    headerClass?: HTMLAttributes['class'];
    contentClass?: HTMLAttributes['class'];
  }>();

  const isOpen = defineModel<boolean>('open');
</script>

<template>
  <Collapsible v-model:open="isOpen" :class="props.class">
    <Card :class="cn('p-0 divide-y gap-0', props.class)">
      <CollapsibleTrigger as-child>
        <CardHeader :class="cn('px-4 py-4 cursor-pointer', headerClass)">
          <slot name="header" :is-open="isOpen" />
        </CardHeader>
      </CollapsibleTrigger>

      <CollapsibleContent>
        <div :class="cn('p-4', contentClass)">
          <slot :is-open="isOpen" />
        </div>
      </CollapsibleContent>
    </Card>
  </Collapsible>
</template>
